<template>
	<div id="indexpage" style="background-color: #041034; height: 100%;">
		<!-- <headerbar msg="chanyednao" :curindex="false"> </headerbar> -->

		<leftnav mkcode="D" itemcode="D-CYFZ" :smScrennFull="true" :title="title"></leftnav>

		<div class="por">
			<!-- 全屏开始 -->
			<i class="el-icon-full-screen swiper_fullscreen" @click="screen()"></i>
			<!-- 全屏结束 -->
			<div class="index-swiper">
				<daswiperNav :title="title" navcode="CYFZ" :indexnum="8" :fulltitle="true"></daswiperNav>
				<span class="screen" @click="drawer2 = true"><i class="el-icon-s-unfold"></i>菜单栏</span>
				<!-- <h2   class="title dataswipertitle" v-on:mouseover="drawer = true" ><span >{{userdata.cityText}}{{title}}	 </span></h2> -->
				<div class="indexflex zshjswiper">
					<div class="col6">
						<div class="cyfz_cyl_saas">
							<ul class="">
								<li class="" @click="cylnav = i; chainid = item.chainId; getajasdata()"
									:class="cylnav == i ? 'lefttbd navbg' : ''" :key="i"
									v-for="(item, i) in pagedata.chainList">{{ item.chainName }}</li>
							</ul>
							<div class="cyfz_cyl_chart">
								<!-- <chain ref="chain" :graphData="chaininformation.graphData"></chain> -->
								<!-- <img src="../../assets/img/cyl1.png" /> -->
								<iframe :src="iframeurl" scrolling="yes" frameborder="none"
									style="width: 100%;height: 100%;"></iframe>
								<div class="iframeMask" @click="chainrouter1(chainid)"></div>
							</div>
						</div>
						<!-- <div class="cyfz_tab transparentbg"> 
									<table border="0" cellspacing="0" cellpadding="0" 	class=""> 
										<tr >  
											<th rowspan="2" class="cyfz_nodename">重点节点</th>
											<th colspan="2">市场规模（亿元）</th>
											<th colspan="7"> 市场机会评估</th>
											<th colspan="3"> 招商机会分析</th>
											<th colspan="3" style="display:none"> 投资机会分析</th>
										</tr>
										<tr class="fwn">
											<th>2019年</th>
											<th>2025年</th>
											<th>市场潜力</th>
											<th>发展阶段</th>
											<th>机会属性</th>
											<th>政策门槛</th>
											<th>竞争门槛</th>
											<th>技术门槛</th>
											<th>资金门槛</th>
											<th class="cyfz_areas">适合区域</th>
											<th style="display:none">选址区域</th>
											<th>招商时机</th>
											<th style="display:none">进入时机</th>
											<th>推荐程度</th>
										</tr>
										<tr class="tboy" v-for="(item,i) in tablist" v-show="i<6">
											<td class="cyfz_nodename">{{item.nodeName}}</td>
											<td>{{item.market}}</td>
											<td>{{item.marketForecast}}</td>
											<td><span  class="stargrade1 stargrade" >
											<el-rate  v-model="item.marketPotential"
													disabled
													show-score
													text-color="#0262de"
													:max="4"
													:colors="strcolors"
													score-template="">
													</el-rate>
											</span> </td> 
											<td><span  class="stargrade1 stargrade" >
											<el-rate  v-model="item.developState"
													disabled
													show-score
													text-color="#0262de"
													:max="4"
													:colors="strcolors"
													score-template="">
													</el-rate>
											</span> </td>
											<td><span  class="stargrade1 stargrade" >
											<el-rate  v-model="item.chanceAttrib"
													disabled
													show-score
													text-color="#0262de"
													:max="4"
													:colors="strcolors"
													score-template="">
													</el-rate>
											</span> </td>
											<td><span  class="stargrade1 stargrade" >
											<el-rate  v-model="item.fundsThreshold"
													disabled
													show-score
													text-color="#0262de"
													:max="4"
													:colors="strcolors"
													score-template="">
													</el-rate>
											</span> </td>
											<td><span  class="stargrade1 stargrade" >
											<el-rate  v-model="item.competeThreshold"
													disabled
													show-score
													text-color="#0262de"
													:max="4"
													:colors="strcolors"
													score-template="">
													</el-rate>
											</span> </td>
											<td><span  class="stargrade1 stargrade" >
											<el-rate  v-model="item.techThreshold"
													disabled
													show-score
													text-color="#0262de"
													:max="4"
													:colors="strcolors"
													score-template="">
													</el-rate>
											</span> </td>
											<td><span  class="stargrade1 stargrade" >
											<el-rate  v-model="item.policyThreshold"
													disabled
													show-score
													text-color="#0262de"
													:max="4"
													:colors="strcolors"
													score-template="">
													</el-rate>
											</span> </td>
											<td class="cyfz_areas">{{item.suitableArea}}</td>
											<td style="display:none">选址区域</td>
											<td><span  class="stargrade1 stargrade" >
											<el-rate  v-model="item.investChance"
													disabled
													show-score
													text-color="#0262de"
													:max="4"
													:colors="strcolors"
													score-template="">
													</el-rate>
											</span> </td>
											<td style="display:none">进入时机</td>
											<td><span  class="stargrade1 stargrade" > 
											<el-rate  v-model="item.recommendLevel"
													disabled
													show-score
													text-color="#0262de"
													:max="4"
													:colors="strcolors"
													score-template="">
													</el-rate></span> 
													</td>
										</tr>  
									</table> 
								</div> -->
					</div>
					<div class="col4">
						<div class="cyfz_zxdt transparentbg">
							<h3 class="cyfz_title">资讯动态</h3>
							<div class="cyfz_zxdt_scorbox">
								<vue-seamless-scroll :data="zxlist" :class-option="defaultOption">
									<!-- :data="colors"  :class-option="defaultOption" -->
									<ul class="flexcss" v-for="(item, i) in zxlist" :key="i">
										<li class="cyfz_zxdt_date">{{ item.publishTime }} </li>
										<li class="cyfz_zxdt_con" @click="routerlinkid('/informationdetail', item.id)">
											{{ item.title }}</li>
									</ul>
								</vue-seamless-scroll>
							</div>
						</div>
						<div class="cyfz_tzjz transparentbg">
							<h3 class="cyfz_title">投资价值综合评估</h3>
							<table border="0" cellspacing="0" cellpadding="0">
								<tr>
									<th>维度</th>
									<th>评级</th>
									<th>说明</th>
								</tr>
								<tr>
									<td>市场机会</td>
									<td class="cyfzz_round cyfzz_round1"><i></i></td>
									<td>{{ pagedata.guide.marketChanceText }}</td>
								</tr>
								<tr>
									<td>发展动力</td>
									<td class="cyfzz_round cyfzz_round1"><i></i></td>
									<td>{{ pagedata.guide.developPowerText }}</td>
								</tr>
								<tr>
									<td>进入壁垒</td>
									<td class="cyfzz_round cyfzz_round2"><i></i></td>
									<td>{{ pagedata.guide.enterRampartText }}</td>
								</tr>
								<tr>
									<td>进入时机</td>
									<td class="cyfzz_round cyfzz_round2">
										<i></i>
										<!-- 	<svg viewBox="0 0 100 100" class="circleSm">
												   <circle r="25" cx="50" cy="50" class="cira" data-role="3" style="stroke-dasharray: 39, 158;">
											  	</circle>
														</svg> -->
									</td>
									<td>{{ pagedata.guide.enterChanceText }}</td>
								</tr>
								<tr>
									<td>推荐指数</td>
									<td class="stargrade1 redstargrade"><i
											v-for="(item, i) in pagedata.guide.recommendScore" :key="i"></i></td>
									<td>{{ pagedata.guide.recommendScoreText }}</td>
								</tr>
							</table>
						</div>
						<div class="cyfz_cyfx transparentbg">
							<h3 class="cyfz_title">产业分析</h3>
							<div class="cyfz_cyfx_con">
								<vue-seamless-scroll :data="pagedata.chainList" :class-option="defaultOption">
									<!-- :data="colors"  :class-option="defaultOption" -->
									<!-- <p><strong>市场机会很大：</strong>医疗器械市场2016年到2022年的市场增量达7300亿元，年均复合增长率为20%，未来市场增量大、增速快，市场机会很大。</p>
								<p><strong>老龄化加剧和分级诊疗等带来市场需求、政策鼓励医疗器械创新并且利好国产替代、人工智能等技术的飞速进步是三个主要驱动力：</strong>人口老龄化加剧、分级诊疗落实和政府对社会办医的鼓励，使个人和基层医疗机构对医疗器械的需求大增；在此背景下，国家颁布政策鼓励医疗器械创新和国产医疗器械发展，各地方政府积极响应；此外，互联网、大数据、人工智能等新技术与医疗器械产业的深度融合，为产业的升级和创新发展带来前所未有的机会。</p>
								<p><strong>行业进入壁垒高：</strong>行业技术壁垒、政策壁垒和资金壁垒高，竞争壁垒中等。</p>
								<p><strong>行业整体处于成长期中期，进入时机好：</strong>医疗器械产业已经发展了一段时间，整体处于成长期中期，但是人工智能等“新技术”的发展使医疗器械这个“老产业”焕发出新活力，整体来看是企业进入投资的好时机。</p>
								<p><strong>综合评估：</strong>投资价值评级为<strong>四颗星</strong>，投资建议为<strong>重点推荐</strong></p> -->
									<!-- {{pagedata.guide.industry}} -->
									<div v-html="pagedata.guide.industry"></div>
								</vue-seamless-scroll>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- </Resize> -->
	</div>
</template>
<script>
export default {
	name: 'chanyefazhan',
	data() {
		return {
			isCollapse: false,
			isFullscreen: false,
			direction: "ltr",  //btt
			direction2: "btt",  //btt
			drawer: false,
			drawer2: false,
			modal: false,
			title: "产业发展数字大屏", bgcolor: "#041034",
			strcolors: ['rgba(26, 147, 251, 0.9)', 'rgba(26, 147, 251, 0.9)', 'rgba(26, 147, 251, 0.9)'],
			userdata: {},
			chaininformation: {},
			yearnav: 1,
			cylnav: 0,
			flag: true,
			graphData: '',
			pagedata: { guide: {}, chainList: [{ chainId: '' }] },
			public_tooltip: {
				trigger: 'axis',
				backgroundColor: 'rgba(255,255,255,0.9)',
				borderColor: '#ddd',
				borderWidth: '1',
				textStyle: {
					color: '#000',
					fontSize: 14,
				}
			},
			mapurl: 'map/city/321200.json',
			colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
			//假数据 
			tablist: [
				{ name: "集成电路", y2019: '	7000~8000', y2025: '	20000~25000', sqql: 4, fzjd: 2, jhsx: 2, zcmk: 1, jzmk: 4, jsmk: 4, zjmk: 4, qy: '一线、二线', zssj: 4, tjcd: 4 },
				{ name: "分立器件", y2019: '	2800~3000', y2025: '4500~5300', sqql: 3, fzjd: 2, jhsx: 2, zcmk: 1, jzmk: 3, jsmk: 3, zjmk: 3, qy: '一线、二线', zssj: 4, tjcd: 4 },
				{ name: "半导体设备", y2019: '130~140', y2025: '400~500', sqql: 4, fzjd: 2, jhsx: 2, zcmk: 1, jzmk: 4, jsmk: 4, zjmk: 3, qy: '一线、二线', zssj: 3, tjcd: 3 },
				{ name: "传感器", y2019: '2000~2500', y2025: '	4500~6000', sqql: 3, fzjd: 2, jhsx: 2, zcmk: 1, jzmk: 3, jsmk: 3, zjmk: 3, qy: '一线、二线', zssj: 4, tjcd: 4 },
				{ name: "芯片制造", y2019: '2000~2500', y2025: '5000~8000', sqql: 4, fzjd: 2, jhsx: 2, zcmk: 1, jzmk: 4, jsmk: 4, zjmk: 4, qy: '一线、二线', zssj: 4, tjcd: 4 },
				{ name: "封装测试", y2019: '2000~2500', y2025: '4000~6000', sqql: 3, fzjd: 2, jhsx: 2, zcmk: 1, jzmk: 4, jsmk: 2, zjmk: 3, qy: '一线、二线', zssj: 4, tjcd: 4 },
			],
			zxlist: [
				{ title: '十四五能源和电力央企有望成为储能项目投资的主力军', publishTime: '2022-03-18' },
				{ title: '激光加速如同按下“快进键” 让粒子跑出“加速度”', publishTime: '2022-03-18' },
				{ title: '低碳化、绿色化、智能化将成为家电行业转型升级新趋势', publishTime: '2022-03-18' },
				{ title: '全球能源正进入数字能源时代 行业现状如何？', publishTime: '2022-03-18' },
				{ title: '从事光伏背板的中来股份也看上了硅料生意', publishTime: '2022-03-17' },
				{ title: '未来新建的风电场寿命或将提高至30年及以上', publishTime: '2022-03-17' },
				{ title: '低碳化、绿色化、智能化将成为家电行业转型升级新趋势', publishTime: '2022-03-18' },
			],
			iframeurl: "",//iframe路径
			chainid: 0
		}
	},
	props: {
		msg: String,
	},
	computed: {
		defaultOption() {
			return {
				step: 0.3, // 数值越大速度滚动越快
				limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			}
		}
	},
	watch: {//深度 watcher
		'cylnav': {
			handler(val, oldVal) {
				this.iframeurl = this.$api.cyl.govsaaschart.chainurl() + "?id=" + this.chainid + "&width=1000";
				console.log(val);
			},
			// deep: true
		}
	},
	created() {
		var _this = this;
		this.userdata = this.getuseriformation();
		// this.iframeurl = this.$api.cyl.govsaaschart.chainurl()+"?id="+this.chainid+"&width=1000";
		// this.iframeurl = this.$api.cyl.govsaaschart.chainurl()+"?id="+this.pagedata.chainList[0].chainId+"&width=1000";
	},
	mounted() {
		document.getElementById('app').style.background = this.bgcolor;
		console.log(document.getElementById('app'));
		this.bus.$emit('loading', true);
		if (this.userdata.edition < 1) {
			var _this = this;
			alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function () {
				_this.routerself('/totalEnterprises');
			}, 1000)
			return;
		}
		this.getajasdata(0);
	},
	methods: {
		getajasdata(type) {
			var _this = this;
			// _this.bus.$emit('loading', true);
			console.log(this.title);
			if (type == 0) {
				var ajaxurl = this.$api.cyl.govsaaschart.industryDevelop();
			} else {
				var ajaxurl = this.$api.cyl.govsaaschart.industryDevelop() + '?chainId=' + _this.chainid;
			}
			this.$axios.get(ajaxurl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log('3213', res);
				if (res.data.success) {
					_this.bus.$emit('loading', false);
					console.log(ajaxurl);
					var datd = res.data.data;
					_this.pagedata = res.data.data;
					_this.zxlist = res.data.list;
					_this.tablist = res.data.data.nodeList;
					if (type == 0) {
						_this.chainid = _this.pagedata.chainList[0].chainId;
						_this.iframeurl = _this.$api.cyl.govsaaschart.chainurl() + "?id=" + _this.pagedata.chainList[0].chainId + "&width=1000";
					}

				} else {
					_this.bus.$emit('loading', false);
				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//产业链跳转详情页
		chainrouter1(chainid) {
			let routeUrl = this.$router.resolve({
				path: '/chain', query: { id: chainid }
			});
			window.open(routeUrl.href, '_blank');
		},
	}
}
</script>

<style>
@import url("../../css/dataswiper.css");
</style>
<style></style>
